<script lang="ts">
import { Canvas } from "@threlte/core";
import { cn } from "$lib/utils";
import ParticleScene from "./ParticleScene.svelte";

interface Props {
  class?: string;
  quantity?: number;
  /** When true, particles fill the nearest positioned parent instead of the viewport */
  contained?: boolean;
}

let {
  class: className = "",
  quantity = 150,
  contained = false,
}: Props = $props();

let containerEl: HTMLDivElement | undefined = $state();
</script>

<div
  bind:this={containerEl}
  class={cn(
    "inset-0 w-full h-full z-0 no-print print:hidden animate-fade-in pointer-events-none",
    contained ? "absolute" : "fixed",
    className,
  )}
  aria-hidden="true"
>
  <Canvas>
    <ParticleScene {quantity} containerEl={contained ? containerEl : undefined} />
  </Canvas>
</div>
